<img
  src="../../../assets/images/logo.svg"
  alt="Navtor logo"
  width="250"
  height="150"
/>
@if (qaBuild) {
  <div
    data-qa-tag="qaBuild"
    class="qa_build"
  >
    <nsp-icon [name]="IconNames.CircleInfo" />
    QA Build
  </div>
}
<form
  [formGroup]="loginForm"
  (ngSubmit)="onLogin()"
>
  <div class="input">
    <label for="username">Username</label>
    <input
      pInputText
      id="username"
      formControlName="username"
      pSize="large"
      placeholder="Username"
      autocomplete="username"
    />
    <label for="password">Password</label>

    <div class="p-fluid">
      <p-password
        id="password"
        formControlName="password"
        size="large"
        placeholder="Password"
        [feedback]="false"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }"
        autocomplete="current-password"
      />
    </div>

    <div class="message">
      @if (authStore.errorMessage()) {
        {{ authStore.errorMessage() }}
      }
    </div>

    <p-fluid>
      <p-button
        class="button"
        label="Sign In"
        [loading]="authStore.isLoggingIn()"
        type="submit"
      />
    </p-fluid>
  </div>

  <div class="checkbox">
    <p-checkbox
      formControlName="keepLoggedIn"
      inputId="keepLoggedIn"
      [binary]="true"
    />
    <label
      for="keepLoggedIn"
      class="ml-2"
    >
      Keep me logged in
    </label>
  </div>
</form>
